import { AlgorithmType, Maze } from "trailz";

import { GameVars } from "../../GameVars";
import { GameConstants } from "../../GameConstants";
import { MazeContainer } from "./MazeContainer";
import { MazeScene } from "./MazeScene";
import { GameManager } from "../../GameManager";

export class MazeManager {

    private static timerEvent: Phaser.Time.TimerEvent;

    private static DEBUG_LEVEL_DURATION: number;

    public static init(): void {

        if (GameConstants.DIFFICULTY_OUTPUT) {
            MazeManager.DEBUG_LEVEL_DURATION = 0;
        }

        MazeManager.timerEvent = GameVars.currentScene.time.addEvent({ delay: 1000, callback: MazeManager.onSecondPassed, callbackScope: MazeManager, loop: true });

        MazeManager.newLevel();
    }

    public static pauseGame(): void {

        GameVars.pause = true;
        
        MazeScene.currentInstance.showPauseLayer();
    }

    public static resumeGame(): void {
        
        GameVars.pause = false;

        MazeScene.currentInstance.hidePauseLayer();
    }
    
    public static newLevel(): void {

        if (GameConstants.DIFFICULTY_OUTPUT) {
            console.error("t: " + MazeManager.DEBUG_LEVEL_DURATION.toString());
            MazeManager.DEBUG_LEVEL_DURATION = 0;
        }

        GameVars.levelCompleted = false;

        GameVars.rows = 24; // eran 24
        GameVars.cols = 14; // eran 14
        GameVars.l = 30;
        GameVars.movingBackwards = false;
        GameVars.justChangedDirection = false;
        GameVars.pathColor = GameConstants.COLOR_NONE;

        // NO CAMBIAR EL ALGORITMO DEL LABERINTO HuntAndKill funciona muy bien
        GameVars.maze = new Maze(GameVars.rows, GameVars.cols, AlgorithmType.HuntAndKill);

        MazeManager.setCursorAndGoalPositions();

        GameVars.path.length = 0;
        GameVars.path.push(GameVars.cursorPosition);

        MazeManager.setPowerUpPositions();

        MazeScene.currentInstance.newLevel();
    }

    public static moveCursor(direction: string): void {

        const mazeCursor = MazeContainer.currentInstance.mazeCursor;

        if (mazeCursor.moving) {
            return;
        }

        if (GameVars.validDirections.indexOf(direction) === -1) {
            MazeScene.currentInstance.invalidDirection();
            return;
        }

        const path = MazeManager.getPath(direction);
        mazeCursor.move(path);

        if (path[0].r === GameVars.path[GameVars.path.length - 1].r && path[0].c === GameVars.path[GameVars.path.length - 1].c) {

            GameVars.justChangedDirection = !GameVars.movingBackwards;
            GameVars.movingBackwards = true;

        } else {

            GameVars.justChangedDirection = GameVars.movingBackwards;
            GameVars.movingBackwards = false;
        }

        GameVars.path.push(GameVars.cursorPosition);

        GameVars.cursorPosition = path[path.length - 1];
        MazeManager.setCursorValidDirections();
    }

    public static cursorMovedOneCell(p: { r: number, c: number }): void {

        let index = -1;

        for (let i = 0; i < GameVars.path.length; i++) {
            if (GameVars.path[i].r === p.r && GameVars.path[i].c === p.c) {
                index = i;
                break;
            }
        }

        if (index === -1) {
            GameVars.path.push(p);
            GameVars.score += 5;
            MazeScene.currentInstance.hud.updateScore();
        } else {

            GameVars.path.pop();
            GameVars.score -= 10;

            if (GameVars.score < 0) {
                GameVars.score = 0;
            }

            MazeScene.currentInstance.hud.updateScore();
        }

        if (GameVars.extraTimePosition !== null && GameVars.extraTimePosition.r === p.r && GameVars.extraTimePosition.c === p.c) {
            GameVars.time += GameConstants.POWER_UP_EXTRA_TIME;
            GameVars.extraTimePosition = null;
            MazeScene.currentInstance.onExtraTime();
        }
    }

    public static cursorStoppedMoving(): void {

        if (GameVars.gameOver) {
            return;
        }

        GameVars.path.pop();

        // comprobar si se ha llegado a la meta
        if (GameVars.cursorPosition.r === GameVars.goalPosition.r && GameVars.cursorPosition.c === GameVars.goalPosition.c) {
            GameVars.levelCompleted = true;
            GameManager.onMazeSolved();
        }
    }

    public static lastTween(): void {

        MazeContainer.currentInstance.lastTween();
    }

    private static onSecondPassed(): void {

        if (GameVars.pause) { 
            return; 
        }

        GameVars.time--;

        if (GameConstants.DIFFICULTY_OUTPUT) {
            MazeManager.DEBUG_LEVEL_DURATION++;
        }

        MazeScene.currentInstance.hud.updateTimer();

        if (GameVars.time === 0) {
            MazeManager.gameOver();
        }
    }

    private static gameOver(): void {

        GameVars.gameOver = true;

        MazeManager.timerEvent.destroy();

        GameManager.gameOver();
    }

    private static getPath(direction: string): { r: number, c: number }[] {

        const path: { r: number, c: number }[] = [];

        let movementData = MazeManager.getNextValidCell(direction, GameVars.cursorPosition);
        path.push(movementData.nextCell);

        let sanity = 0;

        while (movementData.direction !== null && sanity < 100) {

            sanity++;

            movementData = MazeManager.getNextValidCell(movementData.direction, movementData.nextCell);
            path.push(movementData.nextCell);
        }

        return path;
    }

    private static getNextValidCell(direction: string, currentCell: { r: number, c: number }): { nextCell: { r: number, c: number }, direction: string } {

        let nextCell = JSON.parse(JSON.stringify(currentCell));
        let nextDirection: string;

        switch (direction) {

            case GameConstants.DIR_UP:
                nextCell.r--;
                break;

            case GameConstants.DIR_DOWN:
                nextCell.r++;
                break;

            case GameConstants.DIR_LEFT:
                nextCell.c--;
                break;

            case GameConstants.DIR_RIGHT:
                nextCell.c++;
                break;

            default:
                break;
        }

        const value = GameVars.maze.repr[nextCell.r][nextCell.c];

        if (value === 0 || value === 1 || value === 2 || value === 4 || value === 7 || value === 8 || value === 11 || value === 13 || value === 14 || value === 15) {

            nextDirection = null;

        } else {

            switch (value) {

                case 3:

                    if (direction === GameConstants.DIR_DOWN) {
                        nextDirection = GameConstants.DIR_RIGHT;
                    } else {
                        nextDirection = GameConstants.DIR_UP;
                    }

                    break;

                case 5:

                    nextDirection = direction;

                    break;

                case 6:

                    if (direction === GameConstants.DIR_DOWN) {
                        nextDirection = GameConstants.DIR_LEFT;
                    } else {
                        nextDirection = GameConstants.DIR_UP;
                    }

                    break;

                case 9:

                    if (direction === GameConstants.DIR_UP) {
                        nextDirection = GameConstants.DIR_RIGHT;
                    } else {
                        nextDirection = GameConstants.DIR_DOWN;
                    }

                    break;

                case 10:

                    nextDirection = direction;

                    break;

                case 12:

                    if (direction === GameConstants.DIR_RIGHT) {
                        nextDirection = GameConstants.DIR_DOWN;
                    } else {
                        nextDirection = GameConstants.DIR_LEFT;
                    }

                    break;

                default:
                    break;
            }
        }

        return { nextCell: nextCell, direction: nextDirection };
    }

    private static setCursorAndGoalPositions(): void {

        const possiblePositions: { r: number, c: number }[] = [];

        // buscar posiciones de celdas 11, 7, 14 y 13 alejadas
        for (let r = 0; r < GameVars.rows; r++) {
            for (let c = 0; c < GameVars.cols; c++) {
                const value = GameVars.maze.repr[r][c];
                if (value === 11 || value === 7 || value === 14 || value === 13) {
                    possiblePositions.push({ r: r, c: c });
                }
            }
        }

        let d = 0;

        for (let i = 0; i < possiblePositions.length - 1; i++) {

            const p1 = possiblePositions[i];

            for (let j = i; j < possiblePositions.length; j++) {

                const p2 = possiblePositions[j];

                const dist = Math.abs(p1.r - p2.r) + Math.abs(p1.c - p2.c);

                if (dist > d) {
                    d = dist;
                    GameVars.cursorPosition = p1;
                    GameVars.goalPosition = p2;
                }
            }
        }

        MazeManager.setCursorValidDirections();
    }

    private static setPowerUpPositions(): void {

        if (Math.random() > .575) {

            let r = Math.floor(GameVars.rows * Math.random());
            let c = Math.floor(GameVars.cols * Math.random());

            let distToCursor = Math.abs(GameVars.cursorPosition.r - r) + Math.abs(GameVars.cursorPosition.c - c);
            let distToGoal = Math.abs(GameVars.goalPosition.r - r) + Math.abs(GameVars.goalPosition.c - c);

            const d = (GameVars.rows + GameVars.cols) * .35;

            let sanity = 0;

            while ((distToCursor < d || distToGoal < d) && sanity < 100) {

                sanity++;

                r = Math.floor(GameVars.rows * Math.random());
                c = Math.floor(GameVars.cols * Math.random());

                distToCursor = Math.abs(GameVars.cursorPosition.r - r) + Math.abs(GameVars.cursorPosition.c - c);
                distToGoal = Math.abs(GameVars.goalPosition.r - r) + Math.abs(GameVars.goalPosition.c - c);

                if (sanity > 100) {
                    GameVars.extraTimePosition = null;
                    return;
                }
            }

            GameVars.extraTimePosition = { r: r, c: c };

        } else {
            GameVars.extraTimePosition = null;
        }
    }

    private static setCursorValidDirections(): void {

        // poner los valores correctos en GameVars.validDirections
        const value = GameVars.maze.repr[GameVars.cursorPosition.r][GameVars.cursorPosition.c];

        switch (value) {

            case 0:
                GameVars.validDirections = [GameConstants.DIR_UP, GameConstants.DIR_DOWN, GameConstants.DIR_LEFT, GameConstants.DIR_RIGHT];
                break;

            case 1:
                GameVars.validDirections = [GameConstants.DIR_UP, GameConstants.DIR_DOWN, GameConstants.DIR_RIGHT];
                break;

            case 2:
                GameVars.validDirections = [GameConstants.DIR_UP, GameConstants.DIR_LEFT, GameConstants.DIR_RIGHT];
                break;

            case 3:
                GameVars.validDirections = [GameConstants.DIR_UP, GameConstants.DIR_RIGHT];
                break;

            case 4:
                GameVars.validDirections = [GameConstants.DIR_UP, GameConstants.DIR_DOWN, GameConstants.DIR_LEFT];
                break;

            case 5:
                GameVars.validDirections = [GameConstants.DIR_UP, GameConstants.DIR_DOWN];
                break;

            case 6:
                GameVars.validDirections = [GameConstants.DIR_UP, GameConstants.DIR_LEFT];
                break;

            case 7:
                GameVars.validDirections = [GameConstants.DIR_UP];
                break;

            case 8:
                GameVars.validDirections = [GameConstants.DIR_DOWN, GameConstants.DIR_LEFT, GameConstants.DIR_RIGHT];
                break;

            case 9:
                GameVars.validDirections = [GameConstants.DIR_DOWN, GameConstants.DIR_RIGHT];
                break;

            case 10:
                GameVars.validDirections = [GameConstants.DIR_LEFT, GameConstants.DIR_RIGHT];
                break;

            case 11:
                GameVars.validDirections = [GameConstants.DIR_RIGHT];
                break;

            case 12:
                GameVars.validDirections = [GameConstants.DIR_LEFT, GameConstants.DIR_DOWN];
                break;

            case 13:
                GameVars.validDirections = [GameConstants.DIR_DOWN];
                break;

            case 14:
                GameVars.validDirections = [GameConstants.DIR_LEFT];
                break;

            case 15:
                GameVars.validDirections = [];
                break;

            default:
                break;
        }
    }
}
